/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let eventApiUrl = root.eventApiUrl.link;
let eventGalleriesApiUrl = root.eventGalleriesApiUrl.link;
let eventInfoByIDApiUrl = root.eventInfoByIDApiUrl.link;

export default {
  state: {
    eventListState: {},
    getEventInfoByIdState: {}
  },
  mutations: {
    eventListMutation(state, value) {
      Vue.set(state, 'eventListState', value);
    },
    getEventInfoByIdMutation(state, value) {
      Vue.set(state, 'getEventInfoByIdState', value);
    },
  },
  actions: {
    // Get Event List Action
    getEventListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(eventApiUrl).then(res => {
          context.commit('eventListMutation', res);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Get Event Info By Id Action
    getEventInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(eventInfoByIDApiUrl + payload.id + '/').then(res => {
          context.commit('getEventInfoByIdMutation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Post Event Info Action
    postEventInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(eventApiUrl, payload).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Update Event Info Action
    updateEventInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.put(eventApiUrl + payload.data.id + '/', payload.data.data).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // Delete Event Info Action
    deleteEventInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(eventApiUrl + payload.id + '/').then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    getPhotosInGalleriesAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(eventGalleriesApiUrl + payload.id + '/').then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    uploadPhotoInGalleriesAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(eventGalleriesApiUrl, payload).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    removePhotoInGalleriesAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(eventGalleriesApiUrl + payload.id + '/').then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
  getters: {
    eventListGetters: state => state.eventListState,
    getEventInfoByIdGetters: state => state.getEventInfoByIdState,
  }
}